module.exports = __webpack_public_path__ + "static/media/gb-sct.4c2c379f.svg";